import * as React from "react";
import { useTranslation } from "react-i18next";

import CloseIcon from "@mui/icons-material/Close";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import CommonButton from "../../common/button/Button";
import CommonInput from "../../common/input/InputBox";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "300px",
  },
  "& .MuiDialog-paper": {
    // background: "linear-gradient(138deg, #D38C02 2.28%, rgba(255, 200, 94, 0.60) 81.66%), #FFF",
    background: "#FFFCC9",
    borderRadius: "20px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialogTitle-root": {
    padding: theme.spacing(0.5),
  },
}));

interface LotteryProps {
  index?: any;
  open?: any;
  setOpen?: any;
  lotteryIndex?: any;
  handleWinnderUpdate?: any;
  winnerPrize?: any;
  setWinnerPrize?: any;
}
const WinnerDialogBox: React.FC<LotteryProps> = ({
  open,
  setOpen,
  handleWinnderUpdate,
  index,
  winnerPrize,
  setWinnerPrize,
}) => {
  const { t } = useTranslation("translation");

  const handleClose = () => {
    setOpen(false);
  };

  const handleInputChange = (index: any, value: any) => {
    const updateWinnerPrize = [...winnerPrize];
    updateWinnerPrize[index] = value;
    setWinnerPrize(updateWinnerPrize);
  };
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
        maxWidth='md'
      >
        <DialogTitle
          sx={{
            m: 0,
            color: "black",
            textAlign: "center",
            fontFamily: "IBM Plex Sans",
            fontWeight: "bolder",
          }}
          id='customized-dialog-title'
        >
          {t("WinnerDetails")}
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "black",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Grid container display='flex' justifyContent='center' spacing={2}>
            <Grid item sm={6} lg={6} xs={6}>
              <Typography className='winner-typography-dialog'>Lucky ticket,</Typography>
              <Typography className='winner-typography-dialog'>customer wins</Typography>
              <CommonInput
                key={index}
                id={`price-input-box`}
                fullWidth
                className='white-input-box'
                placeholder={t("price")}
                onChange={(e) => handleInputChange(index, e.target.value)}
              />
              <CommonButton
                // disabled={!winnerPrize[index]}
                onClick={(e) => handleWinnderUpdate(index)}
                sx={{ height: "25%", color: "white", fontFamily: "Baloo 2", fontWeight: "900" }}
              >
                {t("sumbit", "Submit")}
              </CommonButton>
            </Grid>
          </Grid>
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
};
export default WinnerDialogBox;
